import {AnimatePresence} from 'framer-motion';
import {motion} from 'framer-motion';
import * as React from 'react';
import Loading from 'src/Loading';
import type {ApolloError} from '@apollo/client';

type ErrorProps = {error: ApolloError};
type Props<T extends {_id: string}> = {
  ifLoading?: JSX.Element;
  ifError?: (props: ErrorProps) => JSX.Element;
  ifEmpty: JSX.Element;
  renderItem: (t: T) => JSX.Element;
  loading: boolean;
  error: ApolloError | undefined;
  data: T[] | undefined;
};

const ListContent = <T extends {_id: string}>(props: Props<T>): JSX.Element => {
  const {ifEmpty, renderItem, loading, error, data} = props;
  const ifLoading = props.ifLoading || <Loading size="medium" />;
  const ifError = props.ifError || (() => <div>error</div>);

  const noData = React.useRef(true);

  React.useEffect(() => {
    if (noData && data) {
      noData.current = false;
    }
  });

  if (data) {
    if (data.length > 0) {
      return (
        <AnimatePresence>
          {data.map((item) => (
            <motion.div
              style={{overflow: 'hidden'}}
              layout
              key={item._id}
              initial={noData ? false : {height: 0}}
              animate={{height: 'auto'}}
              exit={{height: 0}}
            >
              {renderItem(item)}
            </motion.div>
          ))}
        </AnimatePresence>
      );
    } else {
      return ifEmpty;
    }
  } else if (error) {
    return ifError({error});
  } else if (loading) {
    return ifLoading;
  } else {
    return ifLoading;
  }
};

export default ListContent;
